import React, { useState, useEffect } from "react";
import { TextField, Paper, Typography, Box, Button, Container, Alert, Stack } from "@mui/material";
import DashboardLayout from '../Layout/DashboardLayout';
import { getCurrentUser, changePassword } from '../../models/Account';

export default function ChangePassword() {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [userId, setUserId] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getCurrentUser().then((user) => {
            if (user?.id) {
                setUserId(user.id);
            } else {
                setError("Không lấy được thông tin người dùng");
            }
        });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");

        if (!oldPassword) {
            setError("Vui lòng nhập mật khẩu cũ");
            return;
        }
        if (newPassword !== confirmPassword) {
            setError("Mật khẩu xác nhận không khớp");
            return;
        }

        try {
            setLoading(true);
            const res = await changePassword(userId, oldPassword, newPassword);
            setMessage(res.message);
        } catch (err) {
            setError(err?.error || "Có lỗi xảy ra");
        } finally {
            setLoading(false);
        }
    };

    return (
        <DashboardLayout>
            <Container maxWidth="sm" sx={{ mt: 4 }}>
                <Paper sx={{ p: 4 }}>
                    <Typography variant="h5" gutterBottom>🔒 Đổi mật khẩu</Typography>

                    <form onSubmit={handleSubmit}>
                        <Stack spacing={2} sx={{ mb: 2 }}>
                            {message && <Alert severity="success">{message}</Alert>}
                            {error && <Alert severity="error">{error}</Alert>}
                        </Stack>

                        <Box mb={2}>
                            <TextField
                                type="password"
                                label="Mật khẩu cũ"
                                fullWidth
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                            />
                        </Box>
                        <Box mb={2}>
                            <TextField
                                type="password"
                                label="Mật khẩu mới"
                                fullWidth
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                        </Box>
                        <Box mb={3}>
                            <TextField
                                type="password"
                                label="Xác nhận mật khẩu mới"
                                fullWidth
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                        </Box>

                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            fullWidth
                            disabled={loading}
                        >
                            {loading ? "Đang lưu..." : "Lưu thay đổi"}
                        </Button>
                    </form>
                </Paper>
            </Container>
        </DashboardLayout>
    );
}
